import { FavouriteLayoutTypeContext } from 'app/components/favourite-layout/constants';
import { ComplexValue } from 'ui';
import { AttributeMappingType } from './constants';
import { LayoutAttributes } from './types';

export const mapOptionsToLayoutAttributes = (options: ComplexValue<any>[],
  mapping: AttributeMappingType): { 
    [key: string]: string | boolean | number;
    layoutTypeContext?: number;
  }[] => {

  const mappings = [];
  
  !!mapping.hideHeader && mappings.push({
    [mapping.hideHeader]: !options.some(o => o.value === LayoutAttributes.fieldLabels)
  }),

  !!mapping.hideAggrColumns && mappings.push({
    [mapping.hideAggrColumns]: !options.some(o => o.value === LayoutAttributes.quantities)
  });
  !!mapping.compactView && mappings.push({
    [mapping.compactView]: options.some(o => o.value === LayoutAttributes.groups)
  });
  !!mapping.suppressRepeatingRows && mappings.push({
    [mapping.suppressRepeatingRows]: options.some(o => o.value === LayoutAttributes.suppressRepeatingRows)
  });
  !!mapping.wideLayout && mappings.push({
    [mapping.wideLayout]: options.some(o => o.value === LayoutAttributes.wideLayout)
  });
  !!mapping.hideTotals && mappings.push({
    [mapping.hideTotals]: !options.some(o => o.value === LayoutAttributes.totals)
  });
  !!mapping.xAxisLabelsEnabled && mappings.push({
    [mapping.xAxisLabelsEnabled]: options.some(o => o.value === LayoutAttributes.xAxisLabelsEnabled)
  });
  !!mapping.yAxisLabelsEnabled && mappings.push({
    [mapping.yAxisLabelsEnabled]: options.some(o => o.value === LayoutAttributes.yAxisLabelsEnabled)
  });
  !!mapping.showValue && mappings.push({
    [mapping.showValue]: options.some(o => o.value === LayoutAttributes.showValue)
  });
  !!mapping.showPercent && mappings.push({
    [mapping.showPercent]: options.some(o => o.value === LayoutAttributes.showPercent)
  });
  !!mapping.hideDatalabelsOnDashboards && mappings.push({
    [mapping.hideDatalabelsOnDashboards]: options.some(o => o.value === LayoutAttributes.hideDatalabelsOnDashboards),
    layoutTypeContext: FavouriteLayoutTypeContext.Dashboard
  });
  !!mapping.stacked && mappings.push({
    [mapping.stacked]: options.some(o => o.value === LayoutAttributes.stacked)
  });
  !!mapping.percent && mappings.push({
    [mapping.percent]: options.some(o => o.value === LayoutAttributes.percent)
  });
  !!mapping.donutView && mappings.push({
    [mapping.donutView]: options.some(o => o.value === LayoutAttributes.donutView)
  });
  !!mapping.semiCircleView && mappings.push({
    [mapping.semiCircleView]: options.some(o => o.value === LayoutAttributes.semiCircleView)
  });

  return mappings;
};
